export const slides = [
  {
    id: 1,
    word: "VIVID",
    description:
      "Rich, immersive interfaces that captivate and convert.",
  },
  {
    id: 2,
    word: "SHARP",
    description:
      "Pixel-perfect execution from first sketch to final deploy.",
  },
  {
    id: 3,
    word: "SMART",
    description:
      "Intelligent architecture that scales with your ambition.",
  },
  {
    id: 4,
    word: "BOLD",
    description:
      "Fearless strategy and identity that demands attention.",
  },
  {
    id: 5,
    word: "FLUID",
    description:
      "Seamless interactions engineered for every device.",
  },
];
